import { useEffect, useState } from 'react';
import classNames from 'classnames';

import BackgroundImage from './BackgroundImage';
import { SLIDE_TRANSITION_INTERVAL_MS } from './constants';
import type { BackgroundImageShape } from './types';

type Props = {
  backgroundImages: BackgroundImageShape[];
};

const BackgroundSlides = ({ backgroundImages }: Props) => {
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);

  useEffect(() => {
    const slideTransitionInterval = setInterval(() => {
      setCurrentSlideIndex((prevSlideIndex) => (prevSlideIndex + 1) % backgroundImages.length);
    }, SLIDE_TRANSITION_INTERVAL_MS);

    return () => {
      if (slideTransitionInterval) {
        clearInterval(slideTransitionInterval);
      }
    };
  }, [backgroundImages.length]);

  return (
    <>
      {backgroundImages.map((backgroundImage, idx) => (
        <div
          className={classNames('Trsp($opacity) Trsdu($xslow)', {
            'Trsde($xslow) Op(0) ': idx !== currentSlideIndex,
          })}
          key={`photo-${idx}`}
        >
          <BackgroundImage
            // eslint-disable-next-line react/no-array-index-key
            sources={backgroundImage}
          />
        </div>
      ))}
    </>
  );
};

export default BackgroundSlides;
